import camelcaseKeys from 'camelcase-keys';
import { omit, pathOr } from 'ramda';

import {
  initIdentities,
  CurrentUserAttributes,
  checkUserType,
} from 'components/UserMgmt/UserMgmt.helpers';

type Args = {
  profile: CurrentUserAttributes;
};

type Context = {
  cache: { writeData: Function };
};

export const resolvers = {
  setProfile: (
    _: Record<string, unknown>,
    { profile }: Args,
    { cache }: Context,
  ) => {
    const camelcaseProfile = omit(
      [
        'custom:merchantId',
        'custom:merchantId',
        'custom:userType',
        'custom:userRole',
        'identities',
      ],
      camelcaseKeys(profile),
    );

    const merchantId = profile['custom:merchantId'] || null;
    const merchantName = profile['custom:merchantName'] || null;
    const userRole = profile['custom:userRole'] || null;
    const emailVerified = profile['email_verified'] || null;

    const userType = checkUserType(profile);

    let identities = pathOr([initIdentities], ['identities'], profile);
    if (identities && typeof identities === 'string') {
      identities = JSON.parse(identities);
    }

    const userProfile = {
      ...camelcaseProfile,
      merchantId,
      merchantName,
      userType,
      userRole,
      emailVerified,
      identities: [
        {
          ...identities[0],
          __typename: 'identities',
        },
      ],
      __typename: 'profile',
    };

    cache.writeData({
      data: { userProfile },
    });

    return userProfile;
  },
};
